import {AManagerApi} from "@/classes/app/api/manager/a-manager-api";

export default class OwnerAccountEmail extends AManagerApi {
    protected _url: string = '/owner/account/email';
}
